// extracted by mini-css-extract-plugin
module.exports = {"button":"ContactButton_button__1SyFd","text":"ContactButton_text__31QmK"};